const security = {
    grant_type: 'password',
    scope: 'read',
    client_id: process.env.REACT_APP_OAUTH_CLIENT_ID || process.env.EXPO_PUBLIC_OAUTH_CLIENT_ID || '',
    client_secret: process.env.REACT_APP_OAUTH_CLIENT_SECRET || process.env.EXPO_PUBLIC_OAUTH_CLIENT_SECRET || '',
    serverTokenEndpoint: process.env.REACT_APP_OAUTH_TOKEN_ENDPOINT || process.env.EXPO_PUBLIC_OAUTH_TOKEN_ENDPOINT || '',
    serverLogoutEndpoint: process.env.REACT_APP_OAUTH_LOGOUT_ENDPOINT || process.env.EXPO_PUBLIC_OAUTH_LOGOUT_ENDPOINT || '',
    serverRevokeEndpoint: process.env.REACT_APP_OAUTH_REVOKE_ENDPOINT || process.env.EXPO_PUBLIC_OAUTH_REVOKE_ENDPOINT || '',
    serverAuthorizeEndpoint: process.env.REACT_APP_OAUTH_AUTHORIZE_ENDPOINT || process.env.EXPO_PUBLIC_OAUTH_AUTHORIZE_ENDPOINT || '',
    app_id: process.env.REACT_APP_APP_ID || process.env.EXPO_PUBLIC_APP_ID || ''
};

// Log de debug pour vérifier les variables d'environnement (uniquement en développement)
if (process.env.NODE_ENV === 'development') {
    console.log('[ENV DEBUG] OAuth Configuration:', {
        client_id: security.client_id ? '✅ Configuré' : '❌ Manquant',
        client_secret: security.client_secret ? '✅ Configuré' : '❌ Manquant',
        authorizeEndpoint: security.serverAuthorizeEndpoint ? '✅ Configuré' : '❌ Manquant',
        tokenEndpoint: security.serverTokenEndpoint ? '✅ Configuré' : '❌ Manquant',
    });
}

const originOf = (url) => {
    try {
        return url ? new URL(url).origin : '';
    } catch {
        return '';
    }
};

const hosts = {
    api: (process.env.REACT_APP_API_URL || process.env.EXPO_PUBLIC_API_URL || '').replace(/\/$/, ''),
    oauth_api: process.env.REACT_APP_OAUTH_API_HOST || '',
    oauth_exposed: process.env.REACT_APP_OAUTH_EXPOSED_HOST || '',
    location_api: process.env.REACT_APP_LOCATION_API_HOST || '',
    location_exposed: process.env.REACT_APP_LOCATION_EXPOSED_HOST || '',
    media: process.env.REACT_APP_MEDIA_URL || process.env.EXPO_PUBLIC_MEDIA_URL || '',
    pay_web: process.env.REACT_APP_PAY_WEB_URL || process.env.EXPO_PUBLIC_PAY_WEB_URL || '',
    // Checkout public des terminaux : devcheckout.netikash.com en dev, checkout.netikash.com en prod
    checkout: (process.env.REACT_APP_CHECKOUT_URL || 'https://checkout.netikash.com').replace(/\/$/, ''),
    oauth_server: process.env.REACT_APP_OAUTH_SERVER || process.env.EXPO_PUBLIC_OAUTH_SERVER || '',
    // Compte Netikash (profil) : devaccounts.netikash.com en dev, accounts.netikash.com en prod
    accounts: (process.env.REACT_APP_ACCOUNTS_URL
        || originOf(process.env.REACT_APP_OAUTH_AUTHORIZE_ENDPOINT)
        || 'https://accounts.netikash.com').replace(/\/$/, '')
};

// Provider IDs pour les logos et identifications
export const providers = {
    RTL: process.env.REACT_APP_PROVIDER_RTL || process.env.EXPO_PUBLIC_PROVIDER_RTL || '',
    VOD: process.env.REACT_APP_PROVIDER_VOD || process.env.EXPO_PUBLIC_PROVIDER_VOD || '',
    ORG: process.env.REACT_APP_PROVIDER_ORG || process.env.EXPO_PUBLIC_PROVIDER_ORG || '',
    AFR: process.env.REACT_APP_PROVIDER_AFR || process.env.EXPO_PUBLIC_PROVIDER_AFR || '',
    NTK: process.env.REACT_APP_PROVIDER_NTK || process.env.EXPO_PUBLIC_PROVIDER_NTK || '',
    VSA: process.env.REACT_APP_PROVIDER_VSA || process.env.EXPO_PUBLIC_PROVIDER_VSA || ''
};

export const DEFAULT_COUNTRY_CODE = process.env.REACT_APP_DEFAULT_COUNTRY_CODE || '243';

/** Durée de validité d'une demande de paiement (en minutes). Doit correspondre au backend : PaymentRequest.prePersist → plusMinutes(30) */
export const PAYMENT_REQUEST_VALIDITY_MINUTES = 30;

export const storageKeys = {
    session: 'netikash_session',
    user: 'netikash_user',
    organisation: 'netikash_organisation',
    destination: 'netikash_destination',
    solution: 'netikash_solution',
    userPhone: 'netikash_user_phone',
    organizations: 'netikash_organizations'
};

/**
 * Taux de change BCC (Banque Centrale du Congo) pour les factures.
 * À mettre à jour selon le cours officiel (Emmanuel / équipe finance).
 * Utilisé pour afficher sur la facture : 1 USD = X CDF et la date du cours.
 */
export const bccInvoiceConfig = {
    usdToCdf: Number(process.env.REACT_APP_BCC_USD_TO_CDF) || 2850,
    rateDate: process.env.REACT_APP_BCC_RATE_DATE || new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
};

export { security, hosts };


